import React from "react";

interface HomeIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const Bell: React.FC<HomeIconProps> = ({ fill, onClick, width, height }) => {
  return (
    <svg
      width={width ?? "25"}
      height={height ?? "25"}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M16.3336 24.5H11.6669M21.0002 9.33334C21.0002 7.47683 20.2627 5.69635 18.95 4.3836C17.6372 3.07084 15.8567 2.33334 14.0002 2.33334C12.1437 2.33334 10.3632 3.07084 9.05048 4.3836C7.73772 5.69635 7.00023 7.47683 7.00023 9.33334C7.00023 12.9386 6.09077 15.407 5.07483 17.0397C4.21787 18.4169 3.78939 19.1055 3.8051 19.2976C3.8225 19.5103 3.86756 19.5914 4.03896 19.7185C4.19376 19.8333 4.89158 19.8333 6.28722 19.8333H21.7132C23.1089 19.8333 23.8067 19.8333 23.9615 19.7185C24.1329 19.5914 24.178 19.5103 24.1953 19.2976C24.2111 19.1055 23.7826 18.4169 22.9256 17.0397C21.9097 15.407 21.0002 12.9386 21.0002 9.33334Z"
        stroke={fill ?? "#FCFCFD"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Bell;
